export default __webpack_public_path__ + "static/media/CV-Moody-omar.db640981.pdf";